import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Newspaper } from "lucide-react";
import { imageSized } from "../../api";
import { formatDate } from "../../lib/blog";

export default function ArticleCard({ article: a }) {
  return (
    <Link
      to={`/blog/${a.slug}`}
      className="group h-full flex flex-col bg-card rounded-2xl border border-white/10 overflow-hidden hover:border-[#2ED9B8]/25 hover:shadow-[0_24px_50px_-30px_rgba(12,97,82,0.5)] transition-all duration-300"
    >
      <div className="aspect-[16/10] overflow-hidden bg-[#0f2236] flex items-center justify-center">
        {a.cover ? (
          <img
            src={imageSized(a.cover, 800)}
            alt=""
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <Newspaper className="h-10 w-10 text-[#2ED9B8]/50" />
        )}
      </div>
      <div className="p-6 flex flex-col flex-1">
        <span className="inline-block w-fit text-[11px] uppercase tracking-[0.14em] text-[#2ED9B8] bg-[#0f2236] px-2.5 py-1 rounded-full">
          {a.category}
        </span>
        <h3 className="mt-4 font-display text-[21px] leading-snug text-foreground">{a.title}</h3>
        <p className="mt-2 text-sm text-muted-foreground leading-relaxed line-clamp-3 flex-1">{a.excerpt}</p>
        <div className="mt-5 flex items-center justify-between text-xs text-muted-foreground">
          <span>{formatDate(a.published_at)} · {a.read_minutes} min read</span>
          <span className="inline-flex items-center gap-1 text-sm font-medium text-[#2ED9B8] group-hover:gap-2 transition-all">
            Read <ArrowUpRight className="h-4 w-4" />
          </span>
        </div>
      </div>
    </Link>
  );
}
